import React, {Component} from 'react';
import {NavBar,Checkbox,Toast,InputItem} from "antd-mobile";
import { cancellation } from "../../../service/memberService";
import {connect} from "react-redux"; 
import storage from '../../../utils/localStore';
import "./style.less";
const CheckboxItem = Checkbox.CheckboxItem;

@connect(
    state => ({userInfo: state.userInfo})
)
export default class CancelUserCode extends Component {
    constructor(props) {
        super(props);
        this.state = {
            protocolVal: false,
            code:"",
        };
    }

    componentDidMount() {

    }
    Submit = () => {
        // localStorage.removeItem('usr');
        // storage.removeItem('usr');
        // setTimeout(() => {
        //     window.wx.closeWindow()
        // }, 1000)
        
        // this.props.history.push('/pay/myPage');
        // return
        if(this.state.protocolVal === false){
            Toast.info("请阅读勾选同意后注销");
            return
        }
        Toast.loading("",0);
        let params = {
            token: this.props.userInfo.token,
            source:1,
            data:{phone:this.props.userInfo.phone,smsCode:this.state.code}
        };
        cancellation(params).then((res) => {
            if (res.data.code === '0000') {
                localStorage.removeItem('usr');
                storage.removeItem('usr');
                Toast.info('注销成功！',3,()=>{
                    this.props.history.push('/pay/myPage');
                });
            } else {
                Toast.info(res.data.msg);
            }
        })
    };
    inputChange = (v, key) => {
        this.setState({[key]: v,});
    };
    protocolChange =(e)=>{
        this.setState({protocolVal:e.target.checked});
    };
    render() {
        return (
            <div className="cancellation">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()}/>}
                >验证身份</NavBar>

                <div className="warp">
                    <p className="title">验证手机号码</p>
                    <p className='info'>验证码已发送到当前号码</p>
                    <div>
                        <InputItem
                            clear
                            type="code"
                            placeholder="请输入6位验证码"
                            value={this.state.code}
                            onChange={v => this.inputChange(v, 'code')}
                            onBlur={v => window.scroll(0,0)}
                        ></InputItem>
                    </div>
                    <div className="protocol">
                        <CheckboxItem  onChange={(e) => this.protocolChange(e)} checked={this.state.protocolVal}>已阅读并满足以上条件 同意注销</CheckboxItem>
                    </div>
                    <button onClick={this.Submit}>注销</button>
                </div>

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/member/CancelUserCode/index.js